import './bootstrap';

window._ = require('lodash');

import PrimeVue from 'primevue/config';
import 'primeicons/primeicons.css';


import {InertiaProgress} from '@inertiajs/progress'

InertiaProgress.init()

import {createApp, h} from 'vue'
import {createInertiaApp} from '@inertiajs/inertia-vue3'
import {Link} from "@inertiajs/inertia-vue3";
import { createI18n } from 'vue-i18n'

import Layout from "./Layout/Layout";

import SiteButton from "./Components/SiteButton";
import MetaHead from "./Layout/MetaHead";

import Breadcrumb from "./Components/common/Breadcrumb";

import {messages} from "./lang";



const i18n = createI18n({
    locale: window.locale,
    fallbackLocale: 'en', // set fallback locale
    messages,

})

// i18n.global.locale =




createInertiaApp({
    // title: title => `${title} - Byblos Bank Europe`,
    resolve:  async name => {
        const page = (await import(`./Pages/${name}`)).default;
        page.layout = page.layout || Layout;
        return page;
    },
    setup({el, App, props, plugin}) {
        const VueApp = createApp({render: () => h(App, props)})
        VueApp.config.globalProperties.$route = route;
        VueApp.config.unwrapInjectedRef = true;
        VueApp.use(plugin)
            .use(PrimeVue)
            .component('Link',Link)
            .component('site-button', SiteButton)
            .component('MetaHead', MetaHead)
            .component('Breadcrumb',Breadcrumb)
            .use(i18n)
            .mount(el)
    },
});
